export default __webpack_public_path__ + "static/media/Ch_2020-4-1.480089ab.png";